import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';

import {
  Box, createStyles, Dialog, IconButton, makeStyles, Theme, Typography, CircularProgress
} from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';

import {
  UniversalSizeActiveScreen, updateCurrentScreen
} from '../redux/UIOverlayUniversalSizeRedux';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { FareastButton } from './OverlayComponentButton';
import OverlayViewFavoriteModifySize from './OverlayViewGenerateMeasureMethod3Favorite1ModifySize';
import { CalculateClothBodyMeasurementsFromBodyMeasurements, CalculateClothingMeasurementsFromBodyMeasurements, ClothingType, FitType, RoundClothingMeasurementsToHalfPoint } from 'common-ts/dist/models/UserMeasurements';
import { RegularSizeValue } from 'common-ts/dist/models/Cart';
import { PreviousSizeSuggestionElement } from './OverlayViewUniversalSize1SizeSelect';
import { useEffect } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backButton: {
      position: 'absolute',
      top: theme.spacing(3),
      left: theme.spacing(2),
      borderRadius: '50%',
      padding: theme.spacing(1),
    },
    backButtonIcon: {
      padding: '0',
      color: 'black',
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1em 1.5em'
    },
    pageItemsContainer: {
      display: 'grid',
      margin: '2em 1em',
      gridTemplateColumns: '1fr 10fr',
      rowGap: '3em',
    },
    pageTitle: {
      fontSize: '1.1em',
      width: '100%',
      fontWeight: 550,
      marginTop: '5em',
    },
    pageItemIcon: {
      paddingTop: '0.5em',
    },
    pageItemTextBox: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    pageItemTitle: {
      paddingTop: '0.2em',
      fontSize: '0.8em',
      fontWeight: 500,
      gridRow: '1',
    },
    pageItemDescription: {
      gridColumn: '2',
      paddingTop: '0.2em',
      paddingRight: '0.5em',
      fontSize: '0.74em',
      gridRow: '2',
    },
    buatUkuranButton: {
      marginTop: '1em',
      marginLeft: 'auto',
    },
  }),
);

interface Props {
  handleBack: () => void
  handleNext: (updatedCurrentFlowData: any) => void
  currentFlowData: any
  flowVariant: string
  flowInputVariables?: any
}

export default function PersonalSizeCaraBuat({ handleBack, handleNext, currentFlowData, flowVariant, flowInputVariables }: Props) {
  const classes = useStyles()

  useEffect(() => {
    if (flowInputVariables?.clothMeasValue && flowInputVariables?.clothMeasValueNoAdjustment) {
      handleNext({clothMeasValue: flowInputVariables.clothMeasValue});
    }
  }, [flowInputVariables]);

  // WHEN IT IS AUTO SKIPPED / ALREADY INPUT
  if (flowInputVariables?.clothMeasValue && flowInputVariables?.clothMeasValueNoAdjustment) {
    return (
      <Box style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <CircularProgress/>
      </Box>
    );
  }

  if (!currentFlowData?.clothingType) {
    return null;
  }

  return <>
    <Box className={classes.dialogContent}>
      <Typography className={classes.pageTitle} style={{marginTop: flowVariant === 'productDetailInstant' ? '45px' : '30px'}}>
        Sesuaikan yang kurang pas
      </Typography>
      {/* <Typography className={classes.pageItemDescription} style={{margin: '5px 0px 5px', color: '#535353', fontWeight: 300, letterSpacing: '0.1vw'}}>
        Sesuaikan bagian yang kurang pas secukupnya.
      </Typography> */}
      <Typography className={classes.pageItemDescription} style={{margin: '5px 0px 10px', color: '#535353', fontWeight: 300, letterSpacing: '0.1vw'}}>
        Jika sudah pas, klik tombol <span style={{fontWeight: 500, color: '#232323'}}>sudah ok</span> di bawah.
      </Typography>
      {
        flowVariant === 'itemQrScan' ?
        <PreviousSizeSuggestionElement
          srcImageUrl={currentFlowData.productDisplayImage}
          productName={currentFlowData.productName}
          measurementName={currentFlowData.measurementName}
          purchaseDateTime={currentFlowData.purchaseDateString}
          isSelected={false}
          purchaseCount={currentFlowData.purchaseCount}
          clothingType={currentFlowData.clothingType}
          fitType={currentFlowData.fitType}
          userMeasurementsForItem={undefined}
          handleClick={() => {
          }}
          handleConfirmation={() => {
          }}
        /> :
        flowVariant === 'productDetailInstant' ? 
        null : 
        null
      }
      <OverlayViewFavoriteModifySize
        showNumberOfSimiliarProduct={false}
        numberOfSimiliarProduct={2}
        startingClothingBodyMeasurements={
          CalculateClothBodyMeasurementsFromBodyMeasurements(currentFlowData.clothingType as ClothingType, 
            currentFlowData.fitType as FitType, 
            currentFlowData.clothMeasValue as any, RegularSizeValue.L, [])}
        startingClothingMeasurements={
          RoundClothingMeasurementsToHalfPoint(
          CalculateClothingMeasurementsFromBodyMeasurements(currentFlowData.clothingType as ClothingType, 
            currentFlowData.fitType as FitType, 
            currentFlowData.clothMeasValue as any, RegularSizeValue.L))}
        clothingType={currentFlowData.clothingType as ClothingType}
        fitType={currentFlowData.fitType as FitType}
        productId={currentFlowData?.productId}
        productDetail={{}}
        key2={currentFlowData.clothingType + "-" + currentFlowData.fitType}
        onlyUseServiceability={true}
        allowSubmitWithoutChange={true}
        handleSubmit={(value, valueClothing) => {
          handleNext({ // ADDS ONLY clothMeasValue
            clothMeasValue: value
          });
        }}
        isMinimized={true}
        useBodyExtendedMeasRange={true}
        useSizeWheel={true}
        submitText={"SUDAH OK →"}
      />
    </Box>
  </>
}